module.exports = __webpack_public_path__ + "img/wx.b72f2a0e.png";